/* istanbul ignore file */
import { registerDefaultsForModule } from '@glu/theming';

registerDefaultsForModule(
  'modalReact', (
    {
      name,
      palette,
      typography,
      spacing,
      transitions: { duration: { short } }
    }
  ) => {
    const commonTheme = {
      backgroundColor: palette.background,
      color: palette.text.dark,
      closeIconColor: palette.grey.G800,

      body: {
        fontSize: typography.fontSize,
        fontWeight: typography.fontWeight,
        fontFamily: typography.fontFamily,
        padding: `${spacing.unit * 3}px ${spacing.unit * 2.5}px`
      },
      transitionDuration: short,
      dialogMargin: `${spacing.unit * 2}px auto`,

      header: {
        padding: `${spacing.unit * 1.5}px ${spacing.unit * 2.5}px`
      },

      focusColor: palette.focus.normal
    };

    const themes = {
      ash: {
        ...commonTheme,
        maxWidth: 'calc(100% - 20px)',
        width: 500,
        title: {
          ...typography.h3,
          margin: 0
        },
        headerBackground: palette.background,
        icon: {
          marginBottom: 21
        },
        iconSVG: {
          fill: palette.accent,
          height: 48,
          width: 48
        },
        backgroundOpacity: 0.3,
        borderColor: palette.background,
        borderLeft: {
          borderLeft: `4px solid ${palette.info}`,
          content: '""',
          height: 'calc(100% + 2px)',
          left: -5,
          position: 'absolute',
          top: -1
        },
        borderRadius: 0,
        success: palette.info,
        info: palette.info,
        error: palette.error,
        warning: palette.error,
        header: {
          padding: `${spacing.unit * 1.5}px ${spacing.unit * 2.5}px`
        },
        contentTextAlign: 'center',
        close: {
          top: spacing.unit * 3,
          right: spacing.unit * 1.5
        }
      },

      legacy: {
        ...commonTheme,
        width: 768,
        maxWidth: '100%',
        title: {
          ...typography.h4,
          margin: 0
        },
        headerBackground: {
          default: palette.grey.G300,
          success: '#DFF0D6',
          info: palette.primary.light,
          error: '#FECCCD',
          warning: '#FFF7D7'
        },
        icon: {
          marginRight: 10
        },
        iconSVG: { fill: 'VARIANT' },
        backgroundOpacity: 0.25,
        borderColor: palette.grey.G500,
        borderLeft: {},
        borderRadius: 3,
        success: '#8CB566',
        info: palette.info,
        error: palette.error,
        warning: '#eba10e',
        header: {
          padding: `${spacing.unit * 1.5}px ${spacing.unit * 2.5}px`,
          display: 'flex',
          alignItems: 'center'
        },
        contentTextAlign: 'left',
        close: {
          top: spacing.unit * 1.5,
          right: spacing.unit * 1.5
        }
      }
    };

    return themes[name];
  }
);
